import { render, staticRenderFns } from "./LeadChart.vue?vue&type=template&id=fafe3b8e&scoped=true&"
import script from "./LeadChart.vue?vue&type=script&lang=js&"
export * from "./LeadChart.vue?vue&type=script&lang=js&"
import style0 from "./LeadChart.vue?vue&type=style&index=0&id=fafe3b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe3b8e",
  null
  
)

export default component.exports